export default "__VITE_ASSET__f752d35a__"